var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Grid, Input, List, Loader, Message, Segment } from "semantic-ui-react";
import { postJsonWithAuthn } from "../RequestHelpers";
var EmailCurrentVersionModal = /** @class */ (function (_super) {
    __extends(EmailCurrentVersionModal, _super);
    function EmailCurrentVersionModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeCustomNote = function (event, data) {
            var customNote = data.value;
            _this.setState({
                customNote: customNote
            });
        };
        _this.onAddCustomNote = function () {
            _this.setState(function (oldState) {
                var n = oldState.customNote.trim();
                if (n.length > 0) {
                    var notes = new Set(oldState.notes);
                    notes.add(n);
                    return {
                        customNote: '',
                        notes: notes,
                    };
                }
                return oldState;
            });
        };
        _this.addNote = function (note) {
            _this.setState(function (oldState) {
                var notes = new Set(oldState.notes);
                notes.add(note);
                return {
                    notes: notes
                };
            });
        };
        _this.removeNote = function (note) {
            _this.setState(function (oldState) {
                var notes = new Set(oldState.notes);
                notes.delete(note);
                return {
                    notes: notes
                };
            });
        };
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                postJsonWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/email-current-version", JSON.stringify({
                    notes: Array.from(_this.state.notes)
                }))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't send email: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
            customNote: '',
            notes: new Set()
        };
        return _this;
    }
    EmailCurrentVersionModal.prototype.render = function () {
        var _this = this;
        return React.createElement(Dimmer.Dimmable, null,
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(Segment, null,
                React.createElement(Grid, { columns: 2 },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            "Include the following ",
                            this.state.notes.size,
                            " notes:",
                            React.createElement(List, { bulleted: true },
                                this.state.notes.size === 0 && React.createElement(List.Item, null,
                                    React.createElement("em", null, "No notes")),
                                Array.from(this.state.notes).map(function (n, index) {
                                    var removeNote = function () {
                                        _this.removeNote(n);
                                    };
                                    return React.createElement(List.Item, { key: index },
                                        React.createElement(Button, { disabled: _this.state.success, icon: 'delete', negative: true, onClick: removeNote, size: 'tiny' }),
                                        n);
                                })),
                            React.createElement(Form, null,
                                React.createElement(Form.Field, null,
                                    React.createElement(Input, { disabled: this.state.success, onChange: this.onChangeCustomNote, placeholder: "Included additional science", value: this.state.customNote })),
                                React.createElement(Button, { disabled: this.state.customNote.trim().length === 0 || this.state.success, icon: 'plus', label: 'Add custom note', labelPosition: 'left', onClick: this.onAddCustomNote }))),
                        React.createElement(Grid.Column, null,
                            "Suggestions:",
                            React.createElement(List, { bulleted: true }, SUGGESTED_NOTES
                                .map(function (n, index) {
                                var addNote = function () {
                                    _this.addNote(n);
                                };
                                return React.createElement(List.Item, { key: index },
                                    React.createElement(Button, { disabled: _this.state.notes.has(n) || _this.state.success, icon: 'angle left', onClick: addNote, size: 'tiny' }),
                                    React.createElement("span", { style: {
                                            textDecoration: _this.state.notes.has(n) ? 'line-through' : 'none'
                                        } }, n));
                            })))))),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Email sent."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Sending failed."),
            React.createElement("p", null, "Are you sure you want to email the customer?"),
            React.createElement(Button, { disabled: this.state.notes.size === 0 || this.state.success, icon: 'mail', onClick: this.submit, positive: true, label: 'Send email', labelPosition: 'left' }));
    };
    return EmailCurrentVersionModal;
}(React.PureComponent));
export { EmailCurrentVersionModal };
var SUGGESTED_NOTES = [
    'Kit updates.',
    'Handling, dry ice, and/or shipping specified.',
    'State tax specified.',
    'Referral discount added.',
    'Please upload your PO so we can begin production.',
    'You do not need to upload a new PO.',
    'This order includes a Beta Product (see applicable Terms here: https://www.molecularinstruments.com/terms).'
];
//# sourceMappingURL=EmailCurrentVersionModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EmailCurrentVersionModal.js
// module id = 1193
// module chunks = 0